"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCurrentRef = void 0;
const react_1 = require("react");
function useCurrentRef(obj) {
    const ref = react_1.useRef(obj);
    ref.current = obj;
    return ref;
}
exports.useCurrentRef = useCurrentRef;
